import { FormPersonalDetail } from '3-components/OptimizelyForm';
import { useDonationBlockProps } from '../DonationBlockProvider';
import { type FC } from 'react';
import PrivacyLink from '../components/PrivacyLink';
import DonationGiftTile from '../components/DonationGIftTile';
import { useDonationStore } from '../libs/useDonationStore';
import InlineMessage from '3-components/InlineMessage/InlineMessage';
import useFormIdentity from '3-components/OptimizelyForm/hooks/useFormIdentity';

const DetailsForm: FC = () => {
    const { baseURL, personalDetailForm, giftTileSettings, labels } = useDonationBlockProps();

    const { donationData } = useDonationStore();

    const identityToken = useFormIdentity();

    if (!baseURL) {
        console.error('Missing baseURL configuration');
        return null;
    }

    if (!personalDetailForm) {
        console.error('Missing form configuration');
        return null;
    }

    if (!donationData.payment) {
        return (
            <InlineMessage status="error">
                Invalid payment method
            </InlineMessage>
        );
    }

    const { formID, locale } = personalDetailForm;

    return (
        <div className="donation-step-content-wrapper">
            <div className="donation-personal-detail-header">
                {labels?.detailPageIntro && (
                    <div className="personal-detail-title">
                        {labels.detailPageIntro}
                    </div>
                )}
                {labels?.detailPageDescription && (
                    <div className="personal-detail-description">
                        {labels?.detailPageDescription}
                    </div>
                )}
            </div>

            {giftTileSettings?.enable && (
                <div className="donation-personal-detail-gifttile">
                    <DonationGiftTile showImage={false} />
                </div>
            )}

            <div className="personal-detail-form-wrapper">
                <FormPersonalDetail
                    formKey={formID}
                    language={locale}
                    baseUrl={`${baseURL}/`}
                    identityInfo={identityToken}
                />
            </div>

            <PrivacyLink />
        </div>
    );
};

export default DetailsForm;
